import { Box, Button, Container, Grid2 } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

const PushSurvey = () => {
  const [cities, setCities] = useState([]);
  const [survey, setSurvey] = useState({
    surveyName: "",
    userMessage: "",
    uploadLink: "",
  });
  const [filterMap, setFilterMap] = useState({
    age: "",
    education: "",
    durables: [],
    city: "",
    gender: "",
    occupation: "",
  });
  const [isAllUsers, setIsAllUsers] = useState(false);
  const user = useSelector((state) => state.user.user);

  const handleChange = (e) => {
    setSurvey({ ...survey, [e.target.name]: e.target.value });
  };

  const handleChangeFilterMap = (e) => {
    setFilterMap({ ...filterMap, [e.target.name]: e.target.value });
  };

  const handleDurablesChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilterMap({ ...filterMap, durables: values });
  };

  const handlePushSurvey = async (e) => {
    e.preventDefault();
    try {
      if (isAllUsers === true) {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/survey/push-survey`,
          {
            filterMap: null,
            surveyName: survey.surveyName,
            userMessage: survey.userMessage,
            uploadLink: survey.uploadLink,
          },
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        );
        setSurvey({ surveyName: "", userMessage: "", uploadLink: "" });
        setIsAllUsers(false);
        setFilterMap({
          age: "",
          education: "",
          durables: [],
          city: "",
          gender: "",
          occupation: "",
        });
        alert("Survey pushed!");
        console.log("survey added for all users");
      } else {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/survey/push-survey`,
          {
            filterMap: {
              age: filterMap.age || null,
              education: filterMap.education || null,
              durables: filterMap.durables,
              city: filterMap.city || null,
              gender: filterMap.gender || null,
              occupation: filterMap.occupation || null,
            },
            surveyName: survey.surveyName,
            userMessage: survey.userMessage,
            uploadLink: survey.uploadLink,
          },
          {
            headers: {
              Authorization: `Bearer ${user.accessToken}`,
            },
          }
        );
        setSurvey({
          surveyName: "",
          userMessage: "",
          uploadLink: "",
        });
        setFilterMap({
          age: "",
          education: "",
          durables: [],
          city: "",
          gender: "",
          occupation: "",
        });
        alert("Survey pushed!");
        console.log("survey added for selected users");
      }
    } catch (error) {
      alert(error);
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/demographic-data/get-cities`,
          { headers: { Authorization: `Bearer ${user.accessToken}` } }
        );
        setCities(res.data);
        console.log(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchCities();
  }, []);

  const durablesOptions = [
    { value: "AC", label: "Air conditioning (built in NOT portable)" },
    { value: "Kitchen_sink", label: "Kitchen sink" },
    { value: "Dining_table", label: "Dining table" },
    { value: "Oven", label: "Microwave oven" },
    {
      value: "Refrigerator",
      label:
        "Refrigerator(Stand alone – this may have ice box but NOT separate freezer section with its own door)",
    },
    {
      value: "Fridge",
      label:
        "Fridge freezer (i.e. the freezer section has its own door,separate from the refrigerator door)",
    },
    { value: "Washing_machine", label: "Washing machine" },
    { value: "Water_filtering", label: "Water filtering device" },
    { value: "Telephone", label: "Telephone (landline)" },
    { value: "PC", label: "PC/desktop computers" },
    { value: "Motor_cars", label: "Motor cars" },
    { value: "Laptop", label: "Laptop computers" },
    { value: "Camera", label: "Still cameras (digital) " },
    { value: "Video_camera", label: "Video cameras (digital)" },
    { value: "CRT_TV", label: "Colour TVs CRT (cathode ray tube)" },
    { value: "TV", label: "Colour TVs LCD / Plasma TVs" },
    {
      value: "Home_cinema",
      label:
        "Home cinema / theatre / entertainment centre/HDD multimedia player",
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ccc",
      borderRadius: "32px",
      padding: "8px 10px",
      margin: "12px 0",
      fontSize: "14px",
      boxShadow: "none",
      color: "#000",
      backgroundImage:
        "url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\")",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#000000",
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
  };
  return (
    <Container>
      <form
        onSubmit={handlePushSurvey}
        style={{ width: "80%", margin: "auto" }}
      >
        <Box
          sx={{
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <label htmlFor="surveyName">Survey Name</label>
          <input
            type="text"
            name="surveyName"
            id="surveyName"
            placeholder="Survey Name"
            onChange={handleChange}
            style={{ width: "70%" }}
            value={survey.surveyName}
          />
        </Box>
        <Box
          sx={{
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <label htmlFor="userMessage">User Message</label>
          <input
            type="text"
            name="userMessage"
            id="userMessage"
            placeholder="User Message"
            onChange={handleChange}
            style={{ width: "70%" }}
            value={survey.userMessage}
          />
        </Box>
        <Box
          sx={{
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <label htmlFor="uploadLink">Upload Link</label>
          <input
            type="text"
            name="uploadLink"
            id="uploadLink"
            placeholder="Upload Link"
            onChange={handleChange}
            style={{ width: "70%" }}
            value={survey.uploadLink}
          />
        </Box>
        <Grid2 container columnSpacing={2}>
          <Grid2
            size={{ sm: 12, md: 2 }}
            sx={{ display: "flex", alignItems: "center" }}
          >
            All User
            <input
              type="checkbox"
              checked={isAllUsers}
              onChange={() => setIsAllUsers((prev) => !prev)}
              style={{ marginLeft: "10px", width: "20px", height: "20px" }}
            />
          </Grid2>
          <Grid2 size={{ sm: 12, md: 5 }}>
            <select
              name="age"
              id="age"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              value={filterMap.age}
            >
              <option value="" disabled>
                Age
              </option>
              <option value="18-25">18-25</option>
              <option value="26-30">26-30</option>
              <option value="31-35">31-35</option>
              <option value="36-40">36-40</option>
              <option value="41-45">41-45</option>
              <option value="46-50">46-50</option>
              <option value="51-60">51-60</option>
              <option value="60+">More than 60</option>
            </select>
            {/* <select
              name="durables"
              id="durables"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              multiple
              size={1}
            >
              <option value="">Durables Owned</option>
              <option value="Electricity">Electricity</option>
              <option value="LPG_Stove">LPG Stove</option>
              <option value="2-Wheeler">2 Wheeler</option>
              <option value="Fridge">Fridge</option>
              <option value="Washing_Machine">Washing Machine</option>
              <option value="Desktop">Desktop/Laptop</option>
              <option value="4-Wheeler">4 Wheeler</option>
              <option value="AC">AC</option>
              <option value="TV">Colour TV</option>
              <option value="Agriculture_Land">Agriculture_Land</option>
            </select> */}
            <Select
              closeMenuOnSelect={false}
              components={animatedComponents}
              isMulti
              options={durablesOptions}
              onChange={handleDurablesChange}
              value={durablesOptions.filter((option) =>
                filterMap.durables.includes(option.value)
              )}
              classNamePrefix="select"
              isDisabled={isAllUsers}
              placeholder="Durables Owned"
              styles={customStyles}
            />
            <select
              name="gender"
              id="gender"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              value={filterMap.gender}
            >
              <option value="" disabled>
                Gender
              </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </Grid2>
          <Grid2 size={{ sm: 12, md: 5 }}>
            <select
              name="education"
              id="education"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              value={filterMap.education}
            >
              <option value="" disabled>Education</option>
              <option value="Below Secondary/senior/high school">
                Below Secondary/Senior/High School
              </option>
              <option value="Secondary/senior/high school complete">
                Secondary/Senior/High School Complete
              </option>
              <option value="College/university incomplete">
                College/University Incomplete
              </option>
              <option value="College/university complete(graduate)">
                College/University Complete(Graduate)
              </option>
              <option value="Post graduate studies incomplete">
                Post Graduate Studies Incomplete (No Post Graduate Degree)
              </option>
              <option value="Post graduate studies complete">
                Post Graduate Studies Complete (Post Graduate Degree)
              </option>
            </select>
            <select
              name="city"
              id="city"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              value={filterMap.city}
            >
              <option value="" disabled>
                City
              </option>
              {cities.length > 0 ? (
                cities
                  .slice()
                  .sort((a, b) => a.city.localeCompare(b.city))
                  .map((city) => <option key={city} value={city.city}>{city.city}</option>)
              ) : (
                <option value="" disabled>
                  Loading...
                </option>
              )}
            </select>
            <select
              name="occupation"
              id="occuptaion"
              onChange={handleChangeFilterMap}
              disabled={isAllUsers}
              value={filterMap.occupation}
            >
              <option value="" disabled>
                Occupation
              </option>
              <option value="Services">Services</option>
              <option value="Bussiness">Bussiness</option>
              <option value="Self_Employed">Self Employed Proffesional</option>
              <option value="Student">Student</option>
              <option value="Retired">Retired</option>
              <option value="Farmer">Farmer</option>
              <option value="Other">Other</option>
            </select>
          </Grid2>
        </Grid2>
        <Button sx={{ color: "#fff", padding: "10px 20px" }} type="submit">
          Push Survey
        </Button>
      </form>
    </Container>
  );
};

export default PushSurvey;
